export default "__VITE_ASSET__D8nOX7Fp__"